const filtersEl = document.querySelector('[data-collection-filters]')
if (filtersEl) {
  const form = filtersEl.querySelector('[data-filter-form]')

  // On desktop the whole left column (title + filters) collapses when filters
  // are hidden, so the grid can expand into the full width. The width animation
  // therefore targets the sidebar wrapper, not just the filter list.
  const sidebarEl = filtersEl.closest('[data-collection-sidebar]') || filtersEl

  const filterToggle = document.querySelector('[data-filter-toggle]')
  const toggleLabel = filterToggle ? filterToggle.querySelector('[data-filter-toggle-label]') : null

  const desktopQuery = globalThis.matchMedia('(min-width: 769px)')

  function isDesktop() {
    return desktopQuery.matches
  }

  // On desktop the sidebar defaults to open (visible); on mobile it defaults to
  // closed (overlay). Once toggled, the explicit data-open value wins.
  function filtersOpen() {
    if (filtersEl.dataset.open === 'true') return true
    if (filtersEl.dataset.open === 'false') return false
    return isDesktop()
  }

  // Measures the sidebar's natural content width with the width transition
  // momentarily disabled so animating from a collapsed (0px) state has a target.
  function naturalWidth() {
    const prevWidth = sidebarEl.style.width
    const prevTransition = sidebarEl.style.transition
    sidebarEl.style.transition = 'none'
    sidebarEl.style.width = 'auto'
    const width = sidebarEl.offsetWidth
    sidebarEl.style.width = prevWidth
    sidebarEl.getBoundingClientRect()
    sidebarEl.style.transition = prevTransition
    return width
  }

  function animateWidth(open) {
    if (open) {
      const target = naturalWidth()
      sidebarEl.style.width = `${target}px`
      sidebarEl.addEventListener('transitionend', function done(e) {
        if (e.propertyName !== 'width' || e.target !== sidebarEl) return
        // Return to auto so the sidebar stays responsive to content changes.
        sidebarEl.style.width = ''
        sidebarEl.removeEventListener('transitionend', done)
      })
    } else {
      sidebarEl.style.width = `${sidebarEl.offsetWidth}px`
      sidebarEl.getBoundingClientRect()
      sidebarEl.style.width = '0px'
    }
  }

  function setFiltersOpen(open) {
    filtersEl.dataset.open = String(open)
    document.body.classList.toggle('collection-filters-open', open)
    if (toggleLabel) toggleLabel.textContent = open ? 'Hide filters' : 'Show filters'

    if (isDesktop()) {
      animateWidth(open)
    } else {
      // Mobile uses a display-toggled overlay; drop any inline width from desktop.
      sidebarEl.style.width = ''
    }
  }

  document.body.classList.toggle('collection-filters-open', filtersOpen())
  if (toggleLabel) toggleLabel.textContent = filtersOpen() ? 'Hide filters' : 'Show filters'

  // Crossing the breakpoint would strand an inline width (e.g. 0px from a
  // desktop collapse) on the mobile overlay, so clear it off desktop.
  desktopQuery.addEventListener('change', () => {
    if (!isDesktop()) sidebarEl.style.width = ''
  })

  if (filterToggle) {
    filterToggle.addEventListener('click', () => {
      setFiltersOpen(!filtersOpen())
    })
  }

  filtersEl.querySelectorAll('[data-filter-close]').forEach((btn) => {
    btn.addEventListener('click', () => setFiltersOpen(false))
  })

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filtersOpen()) setFiltersOpen(false)
  })

  filtersEl.querySelectorAll('[data-filter-group-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true'
      toggle.setAttribute('aria-expanded', String(!expanded))
      const body = toggle.closest('[data-filter-group]').querySelector('[data-filter-group-body]')
      body.hidden = expanded
    })
  })

  if (form) {
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-filter-checkbox]') && !e.target.matches('[data-filter-price]')) return
      applyFilters()
    })
  }

  function applyFilters() {
    const url = new URL(globalThis.location.href)
    const params = new URLSearchParams()

    // Preserve search context (search results template) so filtering does not
    // drop the query or product-only restriction.
    const q = url.searchParams.get('q')
    if (q) params.set('q', q)
    const type = url.searchParams.get('type')
    if (type) params.set('type', type)

    const sortBy = url.searchParams.get('sort_by')
    if (sortBy) params.set('sort_by', sortBy)

    form.querySelectorAll('[data-filter-checkbox]:checked').forEach((cb) => {
      params.append(cb.name, cb.value)
    })

    form.querySelectorAll('[data-filter-price]').forEach((input) => {
      if (input.value) params.set(input.name, input.value)
    })

    globalThis.location.href = `${url.pathname}?${params.toString()}`
  }
}
